import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { EndUserLicenseAgreementItemFacade } from './end-user-license-agreement-item.facade';

@Injectable({
  providedIn: 'root',
})
export class EndUserLicenseAgreementItemGuard {
  constructor(private eulaItemFacade: EndUserLicenseAgreementItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { eulaItemId },
    } = route;
    return checkStoreState(this.eulaItemFacade, eulaItemId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.eulaItemFacade);
  }
}
